(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[272],{

/***/ 40685:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[pageSlug]",
      function () {
        return __webpack_require__(98576);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91257);








var PageHeader = function(props) {
    var _breadcrumb = props.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, dbName = props.dbName;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var schema = (0,_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .schemaPageHeader */ .ed)(dbName, router.asPath, breadcrumb);
    if (breadcrumb.length > 0) {
        var lastIndex = breadcrumb.length - 1;
        breadcrumb = breadcrumb.map(function(item, index) {
            var link;
            if (lastIndex === index) {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                            id: schema.name,
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(schema)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item-active"])),
                            "aria-current": "page",
                            children: item.title
                        })
                    ]
                }, index);
            } else {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: item.url,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight6x9Svg */ .EO, {
                            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-arrow"])
                        })
                    ]
                }, index);
            }
            return link;
        });
        breadcrumb = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__breadcrumb"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default().breadcrumb),
                    children: breadcrumb
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__container"]), " container"),
            children: breadcrumb
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 2598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69498);



var ReCaptchaWrapper = function(param) {
    var children = param.children, recaptchaActive = param.recaptchaActive, recaptchaKey = param.recaptchaKey;
    if (!+recaptchaActive) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__/* .ReCaptchaProvider */ .dR, {
        useEnterprise: true,
        reCaptchaKey: recaptchaKey,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReCaptchaWrapper);


/***/ }),

/***/ 98576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _pageSlug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 30 modules
var MainLayout = __webpack_require__(75341);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/schemaorg/index.tsx
var schemaorg = __webpack_require__(91257);
// EXTERNAL MODULE: ./components/shared/PageHeader.tsx
var PageHeader = __webpack_require__(64465);
// EXTERNAL MODULE: ./components/ForCWV/CustomPages/custom_site.module.scss
var custom_site_module = __webpack_require__(70433);
var custom_site_module_default = /*#__PURE__*/__webpack_require__.n(custom_site_module);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./api/shop.ts + 1 modules
var shop = __webpack_require__(65564);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/shared/SmartSearch/SmartSearchComponents/WidgetSmartSearch.tsx




var WidgetSmartSearch = function(param) {
    var listItem = param.listItem, stepId = param.stepId, setStepId = param.setStepId, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _forStep = param.forStep, forStep = _forStep === void 0 ? 0 : _forStep, setStep = param.setStep, title = param.title, _defaultMessage = param.defaultMessage, defaultMessage = _defaultMessage === void 0 ? "" : _defaultMessage;
    var ref = (0,react.useState)(false), opened = ref[0], setOpened = ref[1];
    var ref1 = (0,react.useState)(""), enteredItem = ref1[0], setEnteredItem = ref1[1];
    var handleOpen = function() {
        setOpened(!opened);
    };
    (0,react.useEffect)(function() {
        setEnteredItem((stepId === null || stepId === void 0 ? void 0 : stepId.name) || "");
    }, [
        stepId
    ]);
    (0,react.useEffect)(function() {
        document.addEventListener("click", closeWhenDocumentClick);
        return function() {
            document.removeEventListener("click", closeWhenDocumentClick);
        };
    }, [
        opened
    ]);
    var closeWhenDocumentClick = function() {
        if (opened) {
            setOpened(false);
        }
    };
    var handleChooseOption = function(el) {
        if ((stepId === null || stepId === void 0 ? void 0 : stepId.id) !== el.id) {
            setStepId(el);
            setEnteredItem(el.name);
            if (setStep) {
                setStep(forStep);
            }
        }
        setOpened(false);
    };
    var className = classnames_default()("", {
        "smart-search-opened-sort": forStep !== 1,
        "smart-search-opened-sort-step-one": forStep === 1
    });
    var optionalItems = listItem.map(function(el) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "smart-search-sort-option",
            onClick: function() {
                return handleChooseOption(el);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: el.name
            })
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "smart-search-sort-container",
        children: [
            forStep === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "search-smart-for-step-one",
                onClick: function() {
                    return !disabled ? handleOpen() : null;
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "search-smart-enabled",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: enteredItem
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: opened ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DropdownOpenSVG */.bF, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DropdownCloseSVG */.AG, {})
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "smart-search-sort-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "smart-search-sort",
                            onClick: function() {
                                return !disabled ? handleOpen() : null;
                            },
                            children: !disabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "search-smart-enabled",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: enteredItem
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: opened ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DropdownOpenSVG */.bF, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DropdownCloseSVG */.AG, {})
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "search-smart-disabled",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DropdownCloseSVG */.AG, {})
                                })
                            })
                        })
                    })
                ]
            }),
            opened && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: className,
                children: optionalItems
            })
        ]
    });
};
/* harmony default export */ var SmartSearchComponents_WidgetSmartSearch = (WidgetSmartSearch);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/shared/SmartSearch/SmartSearchComponents/SmartSearchStepOne.tsx




var SmartSearchStepOne = function(param) {
    var listItem = param.listItem, dbName = param.dbName, domain = param.domain, setStep2Id = param.setStep2Id;
    var handleChooseCat = function(item) {
        setStep2Id(item);
    };
    var stepOneItems = listItem.map(function(item, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "smart-saerch-item-wrapper",
                onClick: function() {
                    return handleChooseCat(item);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "step-one-img-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(item.image)),
                            alt: item.name,
                            placeholder: "blur",
                            layout: "fill",
                            priority: true,
                            blurDataURL: "/zega/blur1.webp",
                            objectFit: "contain"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "step-one-description",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: item.name
                        })
                    })
                ]
            })
        }, index);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "step-one-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "smart-search-step-one",
                children: stepOneItems
            })
        })
    });
};
/* harmony default export */ var SmartSearchComponents_SmartSearchStepOne = (SmartSearchStepOne);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
;// CONCATENATED MODULE: ./components/shared/SmartSearch/SmartSearchComponents/NewSearch.tsx




var NewSearch = function(param) {
    var translationsData = param.translationsData;
    var router = (0,next_router.useRouter)();
    var pageUrl = (0,es/* useSelector */.v9)(function(state) {
        return state.smartSearch.smartSearchPageUrl;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "new-search-feature",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: function() {
                router.push(pageUrl);
                setTimeout(function() {
                    router.reload();
                }, 1000);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: translationsData.NewSearch
            })
        })
    });
};
/* harmony default export */ var SmartSearchComponents_NewSearch = (NewSearch);

// EXTERNAL MODULE: ./store/smart-search/index.js + 3 modules
var smart_search = __webpack_require__(94192);
// EXTERNAL MODULE: ./components/ForCWV/Products/ProductCard.tsx
var ProductCard = __webpack_require__(84937);
;// CONCATENATED MODULE: ./components/shared/SmartSearch/SmartSearch.tsx













var CustomSmartSearch = function(param) {
    var rootId = param.rootId, translationsData = param.translationsData, selectedLocale = param.selectedLocale, selectedCurrItems = param.selectedCurrItems, dbName = param.dbName, domain = param.domain;
    var locale = (0,next_router.useRouter)().locale;
    var ref = (0,react.useState)(0), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)([]), catData = ref1[0], setCatData = ref1[1];
    var ref2 = (0,react.useState)([]), catData2 = ref2[0], setCatData2 = ref2[1];
    var ref3 = (0,react.useState)([]), catData3 = ref3[0], setCatData3 = ref3[1];
    var ref4 = (0,react.useState)([]), catData4 = ref4[0], setCatData4 = ref4[1];
    var ref5 = (0,react.useState)(), step2Id = ref5[0], setStep2Id = ref5[1];
    var ref6 = (0,react.useState)(), step3Id = ref6[0], setStep3Id = ref6[1];
    var ref7 = (0,react.useState)(), step4Id = ref7[0], setStep4Id = ref7[1];
    var ref8 = (0,react.useState)(), lastStep = ref8[0], setLastStep = ref8[1];
    var ref9 = (0,react.useState)([]), products = ref9[0], setProducts = ref9[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    (0,react.useEffect)(function() {
        dispatch((0,smart_search/* setSmartSearchUrl */.a)(window.location.pathname));
        getCategoriesRoot(rootId, locale);
        setStep(1);
    }, [
        locale
    ]);
    (0,react.useEffect)(function() {
        if (step2Id && step === 1) {
            getChildCategories(step2Id.id, locale, setCatData2);
            setStep(2);
            setStep3Id(null);
        }
        if (step3Id && step === 2) {
            getChildCategories(step3Id.id, locale, setCatData3);
            setStep(3);
            setStep4Id(null);
        }
        if (step4Id && step === 3) {
            getChildCategories(step4Id.id, locale, setCatData4);
            setStep(4);
        }
        if (lastStep && step === 4) {
            var options = {
                catID: lastStep.id,
                slug: lastStep.slug,
                locale: locale,
                domain: domain,
                dbName: dbName
            };
            getProducts(options, setProducts);
            setStep(5);
        }
    }, [
        step2Id,
        step3Id,
        step4Id,
        lastStep,
        locale
    ]);
    var getCategoriesRoot = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(rootId, locale) {
            var rootCat;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            shop["default"].getSmartSearchCats(locale, rootId)
                        ];
                    case 1:
                        rootCat = _state.sent();
                        setCatData(rootCat);
                        return [
                            2
                        ];
                }
            });
        });
        return function getCategoriesRoot(rootId, locale) {
            return _ref.apply(this, arguments);
        };
    }();
    var getChildCategories = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, locale, setCallback) {
            var rootCat;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            shop["default"].getSmartSearchCats(locale, id)
                        ];
                    case 1:
                        rootCat = _state.sent();
                        if (setCallback) {
                            setCallback(rootCat);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function getChildCategories(id, locale, setCallback) {
            return _ref.apply(this, arguments);
        };
    }();
    var getProducts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(options, setCallback) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            shop["default"].getProductsBySmartSearch(options)
                        ];
                    case 1:
                        res = _state.sent();
                        if (setCallback) {
                            setCallback((0,_to_consumable_array/* default */.Z)(res.data));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function getProducts(options, setCallback) {
            return _ref.apply(this, arguments);
        };
    }();
    var productsListItems = products === null || products === void 0 ? void 0 : products.map(function(product, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "products-list__item search-products-card",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                    product: product,
                    dbName: dbName,
                    translationsData: translationsData,
                    backOrderValue: "",
                    selectedCurrItems: selectedCurrItems,
                    selectedLocale: selectedLocale
                })
            })
        }, index);
    });
    var renderSteps = function() {
        if (step <= 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartSearchComponents_SmartSearchStepOne, {
                listItem: catData,
                setStep2Id: setStep2Id,
                dbName: dbName,
                domain: domain,
                step2Id: step2Id
            });
        } else if (step >= 2 && step <= 4) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "smart-search-page-second",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "new-search-feature-top",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartSearchComponents_NewSearch, {
                                    translationsData: translationsData
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartSearchComponents_WidgetSmartSearch, {
                                    setStep: setStep,
                                    forStep: 1,
                                    listItem: catData,
                                    setStepId: setStep2Id,
                                    stepId: step2Id
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "smart-search-optional-steps",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartSearchComponents_WidgetSmartSearch, {
                                    setStep: setStep,
                                    defaultMessage: "step 1",
                                    title: translationsData.TitleOne,
                                    forStep: 2,
                                    listItem: catData2,
                                    setStepId: setStep3Id,
                                    stepId: step3Id
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartSearchComponents_WidgetSmartSearch, {
                                    setStep: setStep,
                                    defaultMessage: "step 2",
                                    title: translationsData.TitleTwo,
                                    forStep: 3,
                                    disabled: step <= 2,
                                    listItem: catData3,
                                    setStepId: setStep4Id,
                                    stepId: step4Id
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartSearchComponents_WidgetSmartSearch, {
                                    setStep: setStep,
                                    defaultMessage: "step 3",
                                    title: translationsData.TitleThree,
                                    forStep: 4,
                                    disabled: step <= 3,
                                    listItem: catData4,
                                    setStepId: setLastStep,
                                    stepId: lastStep
                                })
                            ]
                        })
                    ]
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartSearchComponents_NewSearch, {
                            translationsData: translationsData
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "products-view__content smart-search-products",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "products-list",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "products-list__body",
                                children: productsListItems
                            })
                        })
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "smart-search-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "smart-search",
                children: renderSteps()
            })
        })
    });
};
/* harmony default export */ var SmartSearch = (CustomSmartSearch);

// EXTERNAL MODULE: ./components/builder/BuilderDataRender.tsx + 30 modules
var BuilderDataRender = __webpack_require__(46354);
;// CONCATENATED MODULE: ./components/ForCWV/CustomPages/Content.tsx








var Content = function(props) {
    var content = props.content, domain = props.domain, dbName = props.dbName, selectedCurrItems = props.selectedCurrItems, translationsData = props.translationsData, selectedLocale = props.selectedLocale, getBuilderData = props.getBuilderData, showBuilderData = props.showBuilderData, currencies = props.currencies, backOrderValue = props.backOrderValue, isMobile = props.isMobile, recaptchaActive = props.recaptchaActive, pageSlug = props.pageSlug;
    var _currencies = (0,_sliced_to_array/* default */.Z)(currencies, 1), tmp = _currencies[0], ref = tmp === void 0 ? {} : tmp, tmp1 = ref.code, selectedCurrCode = tmp1 === void 0 ? "" : tmp1, tmp2 = ref.symbol, selectedCurrSymbol = tmp2 === void 0 ? "" : tmp2, tmp3 = ref.exchange_rate, ref1 = tmp3 === void 0 ? {} : tmp3, tmp4 = ref1.rate, selectedCurrRate = tmp4 === void 0 ? "1" : tmp4;
    var builderProps = {
        getBuilderData: getBuilderData,
        domain: domain,
        dbName: dbName,
        translationsData: translationsData,
        selectedLocale: selectedLocale,
        currencies: currencies,
        backOrderValue: backOrderValue,
        selectedCurrItems: {
            selectedCurrCode: selectedCurrCode,
            selectedCurrRate: selectedCurrRate,
            selectedCurrSymbol: selectedCurrSymbol
        },
        isMobile: isMobile,
        recaptchaActive: recaptchaActive
    };
    var showBuilderComponents = function(id) {
        return {
            "true": /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderDataRender/* default */.Z, (0,_object_spread/* default */.Z)({
                tab: id
            }, builderProps)),
            "false": null
        };
    };
    var ref2 = content || {}, tmp5 = ref2.data, ref3 = (0,_sliced_to_array/* default */.Z)(tmp5 === void 0 ? [] : tmp5, 1), tmp6 = ref3[0], ref4 = tmp6 === void 0 ? {} : tmp6, _contentHeight = ref4.contentHeight, contentHeight = _contentHeight === void 0 ? {} : _contentHeight, _page_title = ref4.page_title, page_title = _page_title === void 0 ? "" : _page_title, _hasShortCode = ref4.hasShortCode, hasShortCode = _hasShortCode === void 0 ? false : _hasShortCode, _html_content = ref4.html_content, html_content = _html_content === void 0 ? "" : _html_content, _isTable = ref4.isTable, isTable = _isTable === void 0 ? false : _isTable, _shortCodeId = ref4.shortCodeId, shortCodeId = _shortCodeId === void 0 ? 0 : _shortCodeId;
    var styles = {
        true: {
            overflowX: "auto",
            wordBreak: "break-word"
        },
        false: {
            wordBreak: "break-word"
        }
    };
    var shortCodeView = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartSearch, {
                rootId: shortCodeId,
                translationsData: translationsData,
                selectedCurrItems: selectedCurrItems,
                selectedLocale: selectedLocale,
                dbName: dbName,
                domain: domain
            })
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "page__".concat(pageSlug, "__box"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    style: {
                        textAlign: "center"
                    },
                    dangerouslySetInnerHTML: {
                        __html: page_title
                    }
                })
            }),
            showBuilderComponents(1)["".concat(showBuilderData)],
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((custom_site_module_default()).document, " ").concat(hasShortCode && (custom_site_module_default()).document_with_short),
                        style: contentHeight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: (0,utils/* replaceDescr */.lz)(html_content)
                            },
                            style: styles["".concat(isTable)]
                        })
                    }),
                    shortCodeView["".concat(hasShortCode)]
                ]
            }),
            showBuilderComponents(3)["".concat(showBuilderData)]
        ]
    });
};
/* harmony default export */ var CustomPages_Content = (Content);

;// CONCATENATED MODULE: ./components/ForCWV/CustomPages/SiteCustomPage.tsx








var SiteCustomPage = function(props) {
    var breadcrumb = props.breadcrumb, content = props.content, dbName = props.dbName;
    var router = (0,next_router.useRouter)();
    var schema = (0,schemaorg/* schemaPages */.d8)(props.dbName, router.asPath, content);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: schema.name,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schema)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        dbName: dbName,
                        breadcrumb: breadcrumb
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPages_Content, (0,_object_spread/* default */.Z)({}, props))
                ]
            })
        ]
    });
};
/* harmony default export */ var CustomPages_SiteCustomPage = (SiteCustomPage);

// EXTERNAL MODULE: ./components/shared/ReCaptchaWrapper.tsx
var ReCaptchaWrapper = __webpack_require__(2598);
;// CONCATENATED MODULE: ./pages/page/[pageSlug].tsx











var Page = function(props) {
    var dbName = props.dbName, domain = props.domain, locale = props.selectedLocale, tmp = props.content, ref = tmp === void 0 ? {} : tmp, _data = ref.data, data = _data === void 0 ? [] : _data, _yoast = ref.yoast, yoast = _yoast === void 0 ? [] : _yoast, recaptchaActive = props.recaptchaActive, recaptchaKey = props.recaptchaKey, siteName = props.siteName, defaultLangCode = props.defaultLangCode, locales = props.locales;
    var router = (0,next_router.useRouter)();
    var _data1 = (0,_sliced_to_array/* default */.Z)(data, 1), tmp1 = _data1[0], ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1.meta_title, m_title = tmp2 === void 0 ? data[0].page_title : tmp2, tmp3 = ref1.meta_description, m_desc = tmp3 === void 0 ? "" : tmp3, tmp4 = ref1.meta_keywords, m_keyword = tmp4 === void 0 ? "" : tmp4, tmp5 = ref1.image, m_img = tmp5 === void 0 ? "" : tmp5, tmp6 = ref1.url_key, m_url = tmp6 === void 0 ? "" : tmp6;
    var _yoast1 = (0,_sliced_to_array/* default */.Z)(yoast, 1), tmp7 = _yoast1[0], ref2 = tmp7 === void 0 ? {} : tmp7, tmp8 = ref2.yoast_facebook_title, FB_title = tmp8 === void 0 ? m_title : tmp8, tmp9 = ref2.yoast_facebook_description, FB_desc = tmp9 === void 0 ? m_desc : tmp9, tmp10 = ref2.yoast_twitter_title, TW_title = tmp10 === void 0 ? m_title : tmp10, tmp11 = ref2.yoast_twitter_description, TW_desc = tmp11 === void 0 ? m_desc : tmp11, tmp12 = ref2.yoast_focus_keyword, y_keyword = tmp12 === void 0 ? m_keyword : tmp12;
    var canonicalUrl = "".concat(dbName, "/").concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? locale + "/" : "", "page/").concat(m_url);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptchaWrapper/* default */.Z, {
        recaptchaActive: recaptchaActive,
        recaptchaKey: recaptchaKey,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: m_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "title",
                                content: m_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: m_desc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "keywords",
                                content: m_keyword
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "generator",
                                content: "Zegashop.com"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "robots",
                                content: "index, follow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: TW_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: TW_desc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(m_img))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: FB_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: FB_desc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:keywords",
                                content: y_keyword
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(m_img))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:url",
                                content: (0,helper/* domainUrl */.HJ)(canonicalUrl)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:locale",
                                content: locale
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:site_name",
                                content: siteName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "canonical",
                                href: (0,helper/* domainUrl */.HJ)(canonicalUrl)
                            }),
                            (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/page/").concat(m_url)),
                                        hrefLang: "x-default"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/page/").concat(m_url)),
                                        hrefLang: defaultLangCode
                                    }),
                                    locales.map(function(intl) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                            rel: "alternate",
                                            href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code, "/page/").concat(m_url)),
                                            hrefLang: intl.code
                                        });
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPages_SiteCustomPage, (0,_object_spread/* default */.Z)({
                        pageSlug: m_url
                    }, props))
                ]
            })
        }))
    });
};
var __N_SSP = true;
/* harmony default export */ var _pageSlug_ = (Page);


/***/ }),

/***/ 70433:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"document":"custom_site_document__7beQW","order-success__body":"custom_site_order-success__body__NdAxI","order-success__header":"custom_site_order-success__header__4o1AF","order-success__icon":"custom_site_order-success__icon__0mwiY","order-success__title":"custom_site_order-success__title___ilwW","order-success__subtitle":"custom_site_order-success__subtitle__hT1z1","order-success__actions":"custom_site_order-success__actions__KzbNt","order-success_btn":"custom_site_order-success_btn__jLV3K","document_with_short":"custom_site_document_with_short__bJ1V6","document__header":"custom_site_document__header__5yNi7"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,3071,3997,5341,9774,2888,179], function() { return __webpack_exec__(40685); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);